import ConversationMessageCompositionContent from 'models/composition/conversation_message_composition_content';
import CreateComposition from 'actions/composition/lib/create_composition';
import { MessageChannelType } from 'models/conversation_message';
import {
  canCreateInstagramComposition,
  findCustomerInstagramDisplayName,
  getInstagramFromAddresses,
  normalizeInstagramHandle,
  selectCompanyAddress,
} from 'actions/composition/lib/instagram_composition_helpers';

class CreateInstagramPublicReplyComposition extends CreateComposition {
  constructor(context) {
    super(context, ConversationMessageCompositionContent);
  }

  _createContent({ conversationId, conversationItem }) {
    const conversation = this.customerStores.conversations.find(conversationId);
    const potentialFroms = this._getPotentialFroms(conversation);
    const { companyAddress, companyHandle } = selectCompanyAddress(potentialFroms, conversationItem);

    const customerAddress = conversationItem.content.customerAddress;
    const customerDisplayName = findCustomerInstagramDisplayName(this.customerStores.profile.get(), customerAddress);

    return new ConversationMessageCompositionContent({
      channel: MessageChannelType.INSTAGRAM_COMMENT,
      channelDisplayTitle: 'Instagram Comment',
      companyAddress,
      companyDisplayName: normalizeInstagramHandle(companyHandle),
      customerAddress,
      customerDisplayName,
      meta: { parentCommentId: conversationItem.content.externalId },
    });
  }

  _canCreateComposition() {
    return canCreateInstagramComposition(this.context, config => config?.companyInstagramCommentAddresses?.());
  }

  _getPotentialFroms(conversation) {
    const channelConfiguration = this.context.stores.channelConfiguration.get();
    const instagramCommentEndpoints = channelConfiguration
      ? channelConfiguration.getEndpointsOfType(MessageChannelType.INSTAGRAM_COMMENT)
      : [];
    const allFromAddresses = instagramCommentEndpoints.map(endpoint => ({
      handle: endpoint.configuration.handle,
      id: endpoint.address,
    }));
    const routingGroupId = conversation.assignee.routingGroupId;

    return getInstagramFromAddresses({
      context: this.context,
      allFromAddresses,
      conversation,
      endpoints: instagramCommentEndpoints,
      endpointType: MessageChannelType.INSTAGRAM_COMMENT,
      routingGroupId,
    });
  }
}

export default CreateInstagramPublicReplyComposition;
